<template>
  <div class="member-list">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.userName" clearable placeholder="姓名"></el-input>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.vipNo" clearable placeholder="会员证号"></el-input>
        <el-select v-model="queryParam.agentId" placeholder="现属团体" style="width:200px;margin-right:10px;">
          <el-option v-for="(item, index) in agentList" :key="index" :label="item.agentName" :value="item.agentId"></el-option>
        </el-select>
        <el-select v-model="queryParam.vipCurrentStatus" placeholder="会员现状" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item, key) in $enums.currentStatus" :key="key" :label="item" :value="key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.payStatus" placeholder="交费情况" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item, key) in $enums.vipPayStatus" :key="key" :label="item" :value="key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.politicalStatus" placeholder="政治面貌" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item, key) in $enums.politicalStatus" :key="key" :label="item" :value="key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.systemInfo" placeholder="体制情况" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item, key) in $enums.systemInfo" :key="key" :label="item" :value="key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.specialZhiCheng" placeholder="职称" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item, key) in $enums.specialZhicheng" :key="key" :label="item" :value="key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.infoStatus" placeholder="信息更新状态" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item, key) in $enums.infoStatus" :key="key" :label="item" :value="key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="queryParam=JSON.parse(JSON.stringify(oldQueryParam))" type="default">重置</el-button>
        <el-button @click="handleAdd" type="primary" style="margin-left: 20px;">
          新增会员
        </el-button>
        <KtButton @click="exportExcel()" label="导出会员列表" type="primary" perms="member-list-export"/>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium" @selection-change="multipleSelection=$event">
        <el-table-column prop="vipNo" label="会员证号"></el-table-column>
        <el-table-column prop="currentStatus" label="会员现状">
          <template slot-scope="scope">
            {{$enums.currentStatus[scope.row.currentStatus]}}
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="姓名">
          <template slot-scope="scope">
            <span v-show="!scope.row.trueEye2">
              <span>{{scope.row.userName}}</span>
              <i v-if="scope.row.userName" style="margin-left: 5px;" class="el-icon-view" @click="reloadName(scope.$index, scope.row)"></i>
            </span>
            <span v-show="scope.row.trueEye2">
              <span>{{scope.row.userName2}}</span>
              <i v-if="scope.row.userName2" style="margin-left: 5px;" class="el-icon-view" @click="reloadName(scope.$index, scope.row)"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="sex" label="性别">
          <template slot-scope="scope">
            {{$enums.sex[scope.row.sex]}}
          </template>
        </el-table-column>
        <el-table-column prop="nationality" label="民族"></el-table-column>
        <el-table-column prop="birthday" label="出生日期">
          <template slot-scope="scope">
            {{scope.row.birthday ? $moment(scope.row.birthday).format('YYYY-MM-DD HH:mm') : ''}}
          </template>
        </el-table-column>
        <el-table-column prop="specialWorkunit" label="工作单位"></el-table-column>
        <el-table-column prop="specialZhiwu" label="职务"></el-table-column>
        <el-table-column prop="agentName" label="现属团体"></el-table-column>
        <el-table-column prop="joinTime" label="入会时间">
          <template slot-scope="scope">
            {{scope.row.joinTime ? $moment(scope.row.joinTime).format('YYYY-MM-DD HH:mm') : ''}}
          </template>
        </el-table-column>
        <el-table-column prop="phoneNumber1" label="联系电话">
          <template slot-scope="scope">
            <span v-show="!scope.row.trueEye">
              <span>{{scope.row.phoneNumber1}}</span>
              <i v-if="scope.row.phoneNumber1" style="margin-left: 5px;" class="el-icon-view" @click="reloadIdNo(scope.$index, scope.row)"></i>
            </span>
            <span v-show="scope.row.trueEye">
              <span>{{scope.row.phoneNumber12}}</span>
              <i v-if="scope.row.phoneNumber12" style="margin-left: 5px;" class="el-icon-view" @click="reloadIdNo(scope.$index, scope.row)"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="payStatus" label="会费情况">
          <template slot-scope="scope">
            {{$enums.vipPayStatus[scope.row.payStatus]}}
          </template>
        </el-table-column>
        <el-table-column prop="phoneNumber1" label="信息更新">
          <template slot-scope="scope">
            {{$enums.infoStatus[scope.row.infoStatus]}}
          </template>
        </el-table-column>
        <el-table-column prop="payment" label="会费缴纳" fixed="right" width="80">
          <template slot-scope="scope">
            <el-button type="text" @click="handleDialog(scope.row)">交费</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="detial" label="会员详情" fixed="right" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="turnToDetail(scope.row)">查看信息</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog
      title="会费缴纳"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :destroy-on-close="true">
      <div>
        <div>
          <el-form :model="form" ref="form" label-width="120px" :hide-required-asterisk="true">
            <div @keyup.enter.stop="handleUpdatePayStatus">
              <el-form-item label="交费情况" prop="payStatus" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
                <el-select v-model="form.payStatus" placeholder="交费情况" filterable style="width: 100%;">
                  <el-option v-for="(item, key) in $enums.vipPayStatus" :key="key" :label="item" :value="Number(key)"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="text-right">
          <el-button size="medium" @click="handleClose">取消</el-button>
          <el-button size="medium" type="primary" @click="handleUpdatePayStatus" style="margin-right: 0px;">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtButton from '../../components/ktButton'

export default {
  name: 'member-list',
  components: { KtButton },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId },
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 },
      multipleSelection: [],
      editForm: { show: false, row: null },
      agentList: [],
      nationalityList: [],
      taskInterval: null,
      dialogVisible: false,
      form: {
        payStatus: ''
      },
      applyId: ''
    }
  },
  async created () {
    this.nationalityList = await this.$HTTP.ApiCommon.getNationality()
    this.agentList = await this.$HTTP.ApiMember.agentList()
    await this.getPage()
    // this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2, 3] })
    // if (this.Tool.isNull(this.batchList)) {
    //   throw new Error('没有考试数据')
    // }
    // if (!this.queryParam.batchId) {
    //   this.queryParam.batchId = this.batchList[0].batchId
    // }
    // await this.getSpecialtyList()
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getSpecialtyList (event) {
      this.specialtyList = await this.$HTTP.ApiSpecialty.getList({ batchId: this.queryParam.batchId })
      if (event) {
        this.queryParam.specialtyId = ''
      }
      await this.getPage()
    },
    async getPage (queryParam) {
      try {
        this.editForm.show = false
        this.editForm.row = null
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiMember.vipList(this.queryParam)
        if (page.list) {
          page.list.map(el => {
            this.$set(el, 'phoneNumber12', el.phoneNumber1)
            this.$set(el, 'userName2', el.userName)
            this.$set(el, 'trueEye2', true)
            this.$set(el, 'trueEye', true)
            // el.examineeIdNo2 = el.examineeIdNo.replace(/^(.{6})(?:\w+)/, "\$1********")
            // el.examineeName2 = el.examineeName.replace(/(?<=.)./g, '*')
            if (el.phoneNumber1) {
              el.phoneNumber12 = el.phoneNumber1.replace(/^(\d{3})(\d{4})(\d{4})/g, '$1****$3')
            }
            if (el.userName) {
              el.userName2 = el.userName.replace(/(?<=.)./g, '*')
            }
          })
        }
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async reloadIdNo (index, row) {
      if (row.trueEye == true) {
        this.$set(row, 'trueEye', false)
      } else {
        this.$set(row, 'trueEye', true)
      }
    },
    async reloadName (index, row) {
      if (row.trueEye2 == true) {
        this.$set(row, 'trueEye2', false)
      } else {
        this.$set(row, 'trueEye2', true)
      }
    },
    async exportExcel (row) {
      try {
        await this.$HTTP.ApiMember.exportVipExcel(this.queryParam)
        this.getTaskInfo('export_vip_list')
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async getTaskInfo (taskName) {
      this.taskInterval = setInterval(async () => {
        try {
          let taskInfo = await this.$HTTP.ApiExamResult.getTaskInfo(taskName)
          if (taskInfo) {
            if (taskInfo.errorExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.errorExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.successExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.successExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.percent >= 100) {
              clearInterval(this.taskInterval)
              this.$message({ type: 'success', message: '导入成功' })
              await this.getPage()
            } else if (taskInfo.status >= 2) {
              clearInterval(this.taskInterval)
              if (taskInfo.errMsg) {
                this.$message({ type: 'error', message: taskInfo.errMsg })
              }
              await this.getPage()
            }
          } else {
            clearInterval(this.taskInterval)
          }
        } catch (e) {
          clearInterval(this.taskInterval)
        }
      }, 2000)
    },
    turnToDetail (item) {
      this.$router.push({
        path: '/member/list-detail',
        query: {
          applyId: item.applyId
        }
      })
    },
    // 关闭弹窗
    handleClose () {
      this.applyId = ''
      this.form = {
        payStatus: ''
      }
      this.dialogVisible = false
    },
    // 新增会员
    handleAdd () {
      this.$router.push({
        path: '/member/list-add'
      })
    },
    handleDialog (item) {
      this.applyId = item.applyId
      this.form.payStatus = item.payStatus
      this.dialogVisible = true
    },
    handleUpdatePayStatus () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          try {
            await this.$HTTP.ApiMember.updatePayStatus({
              applyId: this.applyId,
              payStatus: this.form.payStatus
            })
            this.$message.success('操作成功')
            this.handleClose()
            setTimeout(() => {
              this.getPage()
            }, 1000)
          } catch (error) {
            this.$message.error(error.message || '操作失败')
          }
        } else {
          return false
        }
      })
    },
    async updatePayStatus () {
      this.$HTTP.ApiMember.updatePayStatus({
        applyId: this.applyId + 1,
        payStatus: this.form.payStatus
      })
    },
    hasPerms: function (perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms)
    },
    getPermission () { // 模拟接口 获取 权限数据集合
      let perms = this.$store.state.buttonList
      // this.$store.dispatch("SET_PERMISSION", perms)
    }
  }
}
</script>
<style scoped>
  .member-list {
    padding: 20px;
    background-color: #ffffff;
  }
</style>
